import type { FAQItem } from './types';

export const facilitiesFAQs: FAQItem[] = [
  {
    id: 'facility-deposits-cancellations',
    question: 'How do cancellations and deposits work for facilities?',
    answer: `This is planned functionality, not live today. The design supports each amenity defining **cancellation windows** and **deposit policies**:

• Free cancellation before a configured cutoff
• Partial/forfeit charges after the cutoff
• Security deposits collected and returned after inspection
• Blackout dates (maintenance/holidays) and booking windows

Deposit collection and returns depend on a payment processor integration, which is not yet built.`,
    category: 'facilities',
  },
  {
    id: 'facility-booking-rules',
    question: 'What are the facility booking rules and restrictions?',
    answer: `Facility booking is a planned capability. The design supports customized rules per facility:

• **Time Limits:** Maximum booking duration per reservation
• **Advance Notice:** How far ahead residents can book
• **Usage Limits:** Maximum bookings per resident per month
• **Guest Policies:** Number of guests allowed and registration requirements
• **Equipment Checkout:** Tennis rackets, pool furniture, BBQ tools
• **Age Restrictions:** Adult-only hours, children's activity times

This describes intended behavior; facility bookings do not persist in the live product today.`,
    category: 'facilities',
  },
  {
    id: 'facility-maintenance-scheduling',
    question: 'How does facility maintenance scheduling work?',
    answer: `Facility maintenance scheduling is planned to integrate with the booking system:

• **Preventive Scheduling:** Regular maintenance blocks residents from booking
• **Emergency Closures:** Facility shutdowns with resident notifications
• **Vendor Coordination:** Maintenance crews reserving facilities through their portal
• **Damage Reporting:** Residents reporting issues from booking confirmation
• **Inspection Tracking:** Post-maintenance quality checks before reopening
• **Historical Records:** Maintenance logs for board review

This is design intent, not a built feature; neither facility bookings nor maintenance records persist in the live product today.`,
    category: 'facilities',
  },
];
